const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  shopId: state => state.user.shopId,
  roles: state => state.user.roles,
  massagistId: state => state.user.massagistId,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  shopList: state => state.shop.shopList,
  shopListAll: state => state.shop.shopListAll,
  roomList: state => state.shop.roomList,
  massagistList: state => state.shop.massagistList,
  adminUserList: state => state.user.adminUserList,
  projectList: state => state.goods.projectList,
  couponList: state => state.goods.couponList,
  activityDoingList: state => state.goods.activityDoingList,
  productList: state => state.goods.productList,
  approvalCategoryList: state => state.goods.approvalCategoryList,
  approvalCategoryListShop: state => state.goods.approvalCategoryListShop,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js